import { Navigate, NavigateProps, useLocation } from "react-router-dom";

import React from "react";

/**
 * React Navigate doesn't pass query params in the redirect,
 * wrapping Navigate to add the current location to the to attribute.
 */
const RedirectWithLocation = ({
    to,
    ...props
}: NavigateProps & {
    to: string;
}) => {
    const location = useLocation();

    return <Navigate {...props} replace={true} to={{...location, pathname: to}} />
};

export { RedirectWithLocation };
